import { render, staticRenderFns } from "./PaneControl.vue?vue&type=template&id=4b922e03&scoped=true"
import script from "./PaneControl.vue?vue&type=script&lang=js"
export * from "./PaneControl.vue?vue&type=script&lang=js"
import style0 from "./PaneControl.vue?vue&type=style&index=0&id=4b922e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b922e03",
  null
  
)

export default component.exports